module.exports = __webpack_public_path__ + "img/flags/BE.09bbba7.png";